import React, { useState } from 'react';
import { Button, ListGroup } from 'react-bootstrap';
import { SectionHeading } from '../../../form';
import { useFormikContext } from 'formik';
import { ISettingsFormValues } from './types';
import ErrorList from '../../../errorList';
import {
  ConfirmationModal,
  IConfirmationModalProps,
  NotificationModal,
  INotificationModalProps,
  useModal,
} from '../../../modals';
import purgeVisitors from './purgeVisitors';
import autoSignOut from './autoSignOut';
import styles from './DangerZone.module.css';
import { AxiosPromise } from 'axios';

export const DangerZone: React.FC = () => {
  const { values } = useFormikContext<ISettingsFormValues>();
  const { showModal, hideModal } = useModal();

  const [busy, setBust] = useState<boolean>(false);
  const [errors, setErrors] = useState<Array<string>>([]);

  // REFACTOR THIS SO IT DOESNT NEED REPEATING FOR EACH DANGER ACTION
  const performOperation = (
    title: string,
    message: string,
    value: number,
    promiseCallback: (value: number) => AxiosPromise,
    successMessageCallback: (data: any) => string,
  ) => {
    setErrors([]);

    const confirmationProps: IConfirmationModalProps = {
      title,
      message,
      icon: ['far', 'question-circle'],
      kind: 'danger',
      onConfirmed: () => {
        hideModal();
        setBust(true);

        promiseCallback(value)
          .then((response) => {
            const notificationProps: INotificationModalProps = {
              title: 'Operation Complete',
              message: successMessageCallback(response.data),
              icon: ['far', 'check-circle'],
              kind: 'success',
              onRequestClose: () => {
                hideModal();
              },
            };

            showModal(NotificationModal, notificationProps);

            setBust(false);
          })
          .catch((error) => {
            setErrors(error.messages);
            setBust(false);
          });
      },
      onRequestClose: () => hideModal(),
    };

    showModal(ConfirmationModal, confirmationProps);
  };

  const handlePurgeNowClick = () => {
    performOperation(
      'Purge Visitors',
      `Are you sure that you to permanently delete all visitor data that is more than ${values.retainDataForInDays} day(s) old?`,
      values.retainDataForInDays,
      purgeVisitors,
      (data: any) => `${data.count} record(s) were purged`,
    );
  };

  const handleSignOutNowClick = () => {
    performOperation(
      'Sign Out All',
      `Are you sure that you to sign out all visitors that have been signed in for ${values.autoSignOutInHours} hour(s)?`,
      values.autoSignOutInHours,
      autoSignOut,
      (data: any) => `${data.count} visitors were signed out`,
    );
  };

  return (
    <>
      <SectionHeading className={styles.heading}>Danger Zone</SectionHeading>
      <ErrorList errors={errors} />
      <ListGroup>
        <ListGroup.Item className={styles.listItem}>
          <div>
            <span className={styles.listItemTitle}>Purge Visitors</span>
            Manually purge visitor records that are more than{' '}
            {values.retainDataForInDays} day(s) old
          </div>
          <div className={styles.listItemButtonContainer}>
            <Button
              className={styles.button}
              type="button"
              variant="danger"
              onClick={handlePurgeNowClick}
              disabled={busy}
            >
              Purge Now
            </Button>
          </div>
        </ListGroup.Item>
        <ListGroup.Item className={styles.listItem}>
          <div>
            <span className={styles.listItemTitle}>Sign Out All</span>
            Manually sign out anyone that has been signed in for{' '}
            {values.autoSignOutInHours} hour(s) or more
          </div>
          <div className={styles.listItemButtonContainer}>
            <Button
              className={styles.button}
              type="button"
              variant="danger"
              onClick={handleSignOutNowClick}
              disabled={busy}
            >
              Sign Out Now
            </Button>
          </div>
        </ListGroup.Item>
      </ListGroup>
    </>
  );
};

export default DangerZone;
